import { render, staticRenderFns } from "./player-menu.vue?vue&type=template&id=59d4eccc&"
import script from "./player-menu.js?vue&type=script&lang=js&"
export * from "./player-menu.js?vue&type=script&lang=js&"
import style0 from "./player-menu.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports